
(function () {
  'use strict';

  function sundayEndOfWeek() {
    var d = new Date();
    var day = d.getDay();
    var add = (7 - day) % 7;
    return new Date(d.getFullYear(), d.getMonth(), d.getDate() + add);
  }

  function formatOrdinal(date) {
    var month = date.toLocaleDateString(undefined, { month: 'long' });
    var day = date.getDate();
    var ord =
      day % 10 === 1 && day !== 11
        ? 'st'
        : day % 10 === 2 && day !== 12
          ? 'nd'
          : day % 10 === 3 && day !== 13
            ? 'rd'
            : 'th';
    return month + ' ' + day + ord;
  }

  function update() {
    var end = sundayEndOfWeek();
    var text = formatOrdinal(end);
    document.querySelectorAll('[data-preorder-week-end-deadline]').forEach(function (el) {
      el.textContent = text;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }
})();
